import { render, staticRenderFns } from "./NumberOfIllnessesByManning.vue?vue&type=template&id=1c2f811c&scoped=true&"
import script from "./NumberOfIllnessesByManning.vue?vue&type=script&lang=js&"
export * from "./NumberOfIllnessesByManning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2f811c",
  null
  
)

export default component.exports